module.exports = __webpack_public_path__ + "static/img/asdfasdf2.4e757dee.png";